import { TranslateService } from '@ngx-translate/core/';
import { Component, OnInit } from '@angular/core';
import { KontableComponent } from './../../../modules/UIKit/components/kontable/kontable.component';
import { DivisionSalesNetworkService } from '../../../services/division-sales-network/divison-sales-network.service';
import { DivisionSalesNetwork } from '../../../models/division.model';

@Component({
  selector: 'app-division-sales-network',
  templateUrl: './division-sales-network.component.html',
  styleUrls: ['./division-sales-network.component.css']
})
export class DivisionSalesNetworkComponent implements OnInit {

  public showAddEditDialog = false;
  public selectedDSNId: number;
  newDataAvailable = false;
  modalTitle = '';
  labels = {};
  listStates: Array<{label: string, value: string}> = [];
  statusFilter = '0';
  customFilter = KontableComponent.CustomFilter;
  divisions: any[];

  constructor (
    private srvDivisionSalesNetwork: DivisionSalesNetworkService,
    private srvTranslate: TranslateService
  ) { }

  ngOnInit() {
    this.divisions = [];

    this.srvTranslate.get([
      'division_sales_network.add_title',
      'division_sales_network.edit_title',
      'common.all',
      'common.status_notDeleted',
      'common.status_onlyDeleted'
    ])
    .subscribe(res => {
      this.labels['add_title'] = res['division_sales_network.add_title' ];
      this.labels['edit_title'] = res['division_sales_network.edit_title' ];
      this.listStates.push({label: res['common.all'], value: ''});
      this.listStates.push({label: res['common.status_notDeleted'], value: '0'});
      this.listStates.push({label: res['common.status_onlyDeleted'], value: '1'});
    });
    this.srvDivisionSalesNetwork.getSalesNetworkDivisionList().subscribe(res => {
      this.divisions = res;
    });
  }

  showEditDialog(data): void {
    this.selectedDSNId = data.id;
    this.showAddEditDialog = true;
    this.modalTitle = this.labels['edit_title'];
  }

  showAddDialog(): void {
    this.selectedDSNId = 0;
    this.showAddEditDialog = true;
    this.modalTitle = this.labels['add_title'];
  }

  delete (record: DivisionSalesNetwork): void {
    this.srvDivisionSalesNetwork.delete(record.id).subscribe(res => {
      this.newDataAvailable = true;
    });
  }

  salesNetworkAdded(event): void {
    this.newDataAvailable = true;
    this.onDialogHide();
  }

  salesNetworkUpdated(event): void {
    this.newDataAvailable = true;
    this.onDialogHide();
  }

  onDialogHide() {
    this.modalTitle = '';
    this.selectedDSNId = 0;
    this.showAddEditDialog = false;
  }

  recoverDivision(division) {
    this.srvDivisionSalesNetwork.update(division).subscribe(() => this.newDataAvailable = true);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/division-sales-network/division-sales-network.component.ts